<div
  class="transcript-content-inner"
  [class.mobile-transcript]="isMobile"
  #transcriptContentInner
  (scroll)="contentScrolled()"
>
  <!-- speakers -->
  <div class="speaker-item-wrapper" *ngIf="displaySpeaker && speakers.length">
    <div class="speaker-item" *ngFor="let speaker of speakers">
      <div class="speaker-content-container">
        <div class="speaker-name">{{ speaker.fullname }}</div>
        <div class="speaker-position" *ngIf="speaker.position">{{ speaker.position }}</div>
      </div>
      <div class="speaker-image-wrapper">
        <div class="picture-replacement" *ngIf="!speaker.image">
          <span class="initials">{{ speaker.initials }}</span>
        </div>
      </div>
    </div>
  </div>

  <div>
    <p class="check-against-delivery">
      {{ 'Check against delivery' | translate }}
      <span class="mb-transcript-last-speaker-border"></span>
    </p>
  </div>
  <div class="transcript-entry-items">
    <ng-container *ngFor="let entry of entries$ | async">
      <div class="transcript-entry" [attr.data-id]="entry.id" [class.active]="currentEntry?.id === entry.id">
        <ng-container [ngSwitch]="entry.entryType">
          <!-- speker template -->
          <p
            *ngSwitchCase="entryTypes.TEXT"
            class="transcript-entry-item transcript-entry-text"
            [innerHTML]="entry.text"
          ></p>

          <!-- link template -->
          <div *ngSwitchCase="entryTypes.LINK" class="transcript-entry-item transcript-entry-link">
            <a class="transcript-entry-link-wrapper btn btn-plain" [href]="entry.linkUrl" target="_blank">
              <span class="transcript-entry-link-label" [innerHTML]="entry.linkLabel"></span>
              <span class="transcript-entry-link-url" [innerHTML]="entry.linkDisplayUrl"></span>
            </a>
          </div>

          <!-- quote template -->
          <div
            *ngSwitchCase="entryTypes.QUOTE"
            class="transcript-entry-item transcript-entry-item transcript-entry-quote"
          >
            <i class="icon mb-icon-quotation-mark"></i>
            <span class="transcript-entry-quote-text" [innerHTML]="entry.quote"></span>
          </div>

          <!-- image template -->
          <div *ngSwitchCase="entryTypes.IMAGE" class="transcript-entry-item transcript-entry-image">
            <ng-container *ngFor="let media of entry.media">
              <ng-container *ngTemplateOutlet="imageTpl; context: { media: media }"></ng-container>
              <ng-template #imageTpl let-media="media">
                <mb-image [media]="media" (click)="emitOpenMedia(media)"></mb-image>
              </ng-template>
              <mb-action-container [buttonItems]="buttonItems" [resource]="media"></mb-action-container>
            </ng-container>
          </div>

          <!-- video template -->
          <div *ngSwitchCase="entryTypes.VIDEO" class="transcript-entry-item transcript-entry-video">
            <ng-container *ngFor="let media of entry.media">
              <ng-container *ngTemplateOutlet="videoTpl; context: { data: media }"></ng-container>
              <ng-template #videoTpl let-data="data">
                <mb-video
                  *ngIf="data.original"
                  [media]="data"
                  [playerType]="playerType.INLINE"
                  [controls]="false"
                  [hoverVideo]="true"
                  [hideTitle]="true"
                  [muted]="true"
                  (click)="openVideoDialog(data)"
                ></mb-video>
              </ng-template>
              <mb-action-container [buttonItems]="buttonItems" [resource]="media"></mb-action-container>
            </ng-container>
          </div>

          <!-- document template -->
          <div *ngSwitchCase="entryTypes.DOCUMENT" class="transcript-entry-item transcript-entry-document">
            <ng-container *ngFor="let media of entry.media">
              <ng-container *ngTemplateOutlet="documentTpl; context: { data: media }"></ng-container>
              <ng-template #documentTpl let-data="data">
                <mb-document-card
                  [document]="data"
                  [actions]="buttonItems"
                  (click)="emitOpenMedia(media)"
                ></mb-document-card>
              </ng-template>
            </ng-container>
          </div>

          <!-- audio template -->
          <div *ngSwitchCase="entryTypes.AUDIO" class="transcript-entry-item transcript-entry-audio">
            <ng-container *ngFor="let media of entry.media">
              <ng-container *ngTemplateOutlet="fooTpl; context: { data: media }"></ng-container>
              <ng-template #fooTpl let-data="data">
                <mb-audio
                  class="no-bg compact"
                  [media]="data"
                  [actions]="buttonItems"
                  [disablePlay]="disableActionAssets"
                  (disablePlayClick)="checkCanOpen()"
                ></mb-audio>
              </ng-template>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div *ngIf="entry.isLast && entry.speaker" class="last-speaker-entry">
        {{ entry.speaker.fullname }}
        <span class="last-speaker-entry-border"></span>
      </div>
    </ng-container>
  </div>

  <mb-buffering *ngIf="isLoading()"></mb-buffering>
</div>
